import type { ComponentProps } from 'react'

import NextLink from 'next/link'

/**
 * Host-provided `LinkComponent` for `DesignSystemProvider`.
 *
 * b2b customer app uses `basePath: ''`, so no stripping is needed.
 * This adapter simply delegates to Next's `<Link>`.
 */
type Props = ComponentProps<typeof NextLink>

export const NextLinkAdapter = ({ href, ...props }: Props) => (
  <NextLink {...props} href={href} legacyBehavior={false} />
)
